import { render, staticRenderFns } from "./adminOverview.vue?vue&type=template&id=a74bd87a&scoped=true"
import script from "./adminOverview.vue?vue&type=script&lang=js"
export * from "./adminOverview.vue?vue&type=script&lang=js"
import style0 from "./adminOverview.vue?vue&type=style&index=0&id=a74bd87a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a74bd87a",
  null
  
)

export default component.exports